import { computed, ComputedRef, inject, provide, Ref } from "vue";
import { injectCarouselContext } from "../lib/provideInjectors";
import { Dimensions } from "@fresh8/vue-utils/src/dimensionSync";
import { injectAdSize } from "./useAdSize";

export const SQUARISH = "squarish";
export const LANDSCAPE = "landscape";
export const SMALL_RESPONSIVE = "small-responsive";
export const LEADERBOARD = "leaderboard";

export function useLayout(
  dimensions: Ref<Dimensions> = injectAdSize()
): {
  dimensions: Ref<Dimensions>;
  layout: ComputedRef<"small-responsive" | "squarish" | "landscape">;
  SQUARISH: string;
} {
  const carouselContext = injectCarouselContext();

  const layout = computed(() => {
    const { width, height } = dimensions.value;

    if (carouselContext.value.isCarousel) {
      if (height < 200) {
        return SMALL_RESPONSIVE;
      }
      return SQUARISH;
    }

    if (width <= 450) {
      if (height < 200) {
        return SMALL_RESPONSIVE;
      }
      return SQUARISH;
    } else {
      if (height < 200) {
        return SMALL_RESPONSIVE;
      }
      return LANDSCAPE;
    }
  });

  return {
    dimensions,
    layout,
    SQUARISH
  };
}

export type LayoutContext = ReturnType<typeof useLayout>;
export const LayoutSymbol = Symbol("LayoutSymbol");

export function provideLayout(layoutContext: LayoutContext): void {
  provide(LayoutSymbol, layoutContext);
}
export function injectLayout(): LayoutContext | undefined {
  return inject<LayoutContext>(LayoutSymbol);
}
